export function getPopupPosition(element: Element, target: Element, container: Element)
{
    let documentPosition  = document.documentElement.getBoundingClientRect();
    let containerPosition = container.getBoundingClientRect();
    let targetPosition    = target.getBoundingClientRect();
    
    let left = Math.round((target.clientWidth - element.clientWidth) / 2) + targetPosition.left;

    if (left + element.clientWidth > containerPosition.left + container.clientWidth) {
        left = containerPosition.left + container.clientWidth - element.clientWidth;
    }

    if (left < containerPosition.left) {
        left = containerPosition.left;
    }

    return {
        top: targetPosition.top - documentPosition.top - element.clientHeight,
        left: left,
    }
}

export function getCursorPosition(cursor: Element, parent: Element, target: Element)
{
    let parentPosition = parent.getBoundingClientRect();
    let targetPosition = target.getBoundingClientRect();
    let cursorLeft     = Math.round((target.clientWidth - cursor.clientWidth) / 2)
        + targetPosition.left - parentPosition.left;
        
    return {
        left: cursorLeft,
    }
}
